import { render, staticRenderFns } from "./CustomerPickerPromt.vue?vue&type=template&id=145dc411&scoped=true&"
import script from "./CustomerPickerPromt.vue?vue&type=script&lang=js&"
export * from "./CustomerPickerPromt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145dc411",
  null
  
)

export default component.exports